export default __webpack_public_path__ + "static/media/cafeBanner.24ca0bb7.jpg";